import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { MainBox, UserName } from '../Elements';
import { useSelector, useDispatch } from 'react-redux';
import { CustomGreenLargeButton } from '../../components/Button';
import { FormBoxA, FormBox, CustomListItemText } from './Elements';
import { Grid, Avatar, List, ListItemAvatar, CircularProgress } from '@mui/material';
import { useMediaQuery, ListSubheader, ListItem } from '@mui/material';
import { updateFuntion, getFunction } from '../../features/auth/action';
import { paidUserSettingsList, guestUserSettingsList } from '../../data';

import Sidebar from '../../components/Sidebar';
import right from '../../assets/settings/right.png';
import CustomSwitch from '../../components/Button/Switch';
import DeleteUserModal from '../../components/Modal/DeleteUserModal';

import api from '../../api';

const Settings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matches600 = useMediaQuery('(max-width:600px)');

  const { role, userInfo, isAuth } = useSelector((state) => state.auth);

  const [enable, setenable] = useState(userInfo?.notificationEnabled);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const apiCall = () => {
    let body = { name: 'userInfo', url: `/user/getUser/${userInfo?._id}` };
    dispatch(getFunction(body));
    setenable(userInfo?.notificationEnabled);
  };
  const handleEnable = async () => {
    const value = !enable;
    setenable(value);
    const body = {
      url: `/user/${userInfo?._id}`,
      _id: userInfo?._id,
      notificationEnabled: value,
    };
    dispatch(updateFuntion(body));
    apiCall();
  };

  const getSubscriptionStatus = async () => {
    try {
      if (!userInfo?.customerId) {
        // No customer ID means no subscription
        setSubscriptionStatus(null);
        return;
      }
      
      setIsLoading(true);
      const response = await api.get(`/stripe/getActive/${userInfo?.customerId}`);
      setSubscriptionStatus(response?.data?.status);
      console.log("subscriptionStatus: ", response?.data?.status);
    } catch (error) {
      setSubscriptionStatus(null);
    } finally {
      setIsLoading(false);
    }
  }

  // Navigation handlers that prevent navigation during loading
  const handleCardsNavigation = () => {
    if (isLoading) return; // Don't navigate while loading
    
    if (subscriptionStatus === 'Premium' || subscriptionStatus === 'PremiumC') {
      navigate('/manage/cards');
    } else {
      navigate('/freePlan');
    }
  };

  const handleSubscriptionNavigation = () => {
    if (isLoading) return; // Don't navigate while loading
    
    if (subscriptionStatus === 'Premium' || subscriptionStatus === 'PremiumC') {
      navigate('/manageSubscription');
    } else {
      navigate('/freePlan');
    }
  };

  useEffect(() => {
    if (isAuth) {
      apiCall();
      getSubscriptionStatus()
    }
    // eslint-disable-next-line
  }, []);
  return (
    <MainBox sx={{ marginTop: matches600 ? 6 : 0, height: '100vh' }}>
      <Sidebar />
      <FormBox>
        <FormBoxA sx={{ height: 'max-content' }}>
          <List
            subheader={
              <ListSubheader>
                <UserName sx={{ fontSize: '18px', mb: 3, mt: 1 }}>Account Settings</UserName>
              </ListSubheader>
            }
          >
            {role === 'guest'
              ? guestUserSettingsList.map((res, i) => {
                  const IconComponent = res.icon;
                  return (
                    <ListItem sx={{ pl: 1.6 }} key={i}>
                      <ListItemAvatar>
                        <Avatar sx={{ background: '#F2F3F1' }}>
                           <IconComponent 
                             sx={{ 
                               color: '#30563A !important',
                               opacity: res.name === 'Blocked Users' ? 0.5 : 1,
                               fontSize: '20px'
                             }} 
                           />
                        </Avatar>
                      </ListItemAvatar>
                      <CustomListItemText
                        id="switch-list-label-wifi"
                        style={{ opacity: res.name === 'Blocked Users' ? 0.5 : 1 }}
                        primary={res.name}
                      />
                      {res.name === 'Notifications' && (
                        <CustomSwitch handleToggle={handleEnable} checked={enable} />
                      )}
                      {res.name === 'Blocked Users' && (
                        <img src={right} alt="right" style={{ cursor: 'pointer', opacity: 0.5 }} />
                      )}
                    </ListItem>
                  );
                })
              : paidUserSettingsList.map((res, i) => {
                  const IconComponent = res.icon;
                  return (
                    <ListItem sx={{ pl: 1.6 }} key={i}>
                      <ListItemAvatar>
                        <Avatar sx={{ background: '#F2F3F1' }}>
                          <IconComponent sx={{ color: '#30563A !important', fontSize: '20px' }} />
                        </Avatar>
                      </ListItemAvatar>
                      {res.name === 'Change Password' && (
                        <CustomListItemText
                          id="switch-list-label-wifi"
                          onClick={() => navigate('/changepassword')}
                          primary={'Change Password'}
                        />
                      )}
                      {res.name === 'Cards' && (
                        <>
                          <CustomListItemText
                            id="switch-list-label-wifi"
                            onClick={handleCardsNavigation}
                            primary={'Cards'}
                            style={{ opacity: isLoading ? 0.7 : 1 }}
                          />
                          {isLoading && (
                            <CircularProgress 
                              size={16} 
                              sx={{ 
                                color: '#30563A',
                                marginLeft: '8px'
                              }} 
                            />
                          )}
                        </>
                      )}
                      {res.name === 'Manage Subscription' && (
                        <>
                          <CustomListItemText
                            id="switch-list-label-wifi"
                            onClick={handleSubscriptionNavigation}
                            primary={'Manage Subscription'}
                            style={{ opacity: isLoading ? 0.7 : 1 }}
                          />
                          {isLoading && (
                            <CircularProgress 
                              size={16} 
                              sx={{ 
                                color: '#30563A',
                                marginLeft: '8px'
                              }} 
                            />
                          )}
                        </>
                      )}
                      {res.name === 'Notifications' && (
                        <>
                          <CustomListItemText id="switch-list-label-wifi" primary={res.name} />
                          <CustomSwitch handleToggle={handleEnable} checked={enable} />
                        </>
                      )}
                      {res.name === 'Blocked Users' && (
                        <>
                          <CustomListItemText
                            id="switch-list-label-wifi"
                            primary={res.name}
                            onClick={() => navigate('/settings/blockedusers')}
                          />
                          <img
                            src={right}
                            alt="right"
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate('/settings/blockedusers')}
                          />
                        </>
                      )}
                      {res.name === 'Delete Account' && (
                        <CustomListItemText
                          id="switch-list-label-wifi"
                          // onClick={() => navigate('/changepassword')}
                          // primary={'Delete Account'}
                        >
                           <DeleteUserModal user={userInfo}/>
                        </CustomListItemText>
                      )}
                      {res.name === 'Email Notifications' && (
                         <>
                         <CustomListItemText
                           id="switch-list-label-wifi"
                           primary={res.name}
                           onClick={() => navigate('/settings/email-management')}
                         >
                           <img
                             src={right}
                             alt="right"
                             style={{ cursor: 'pointer' }}
                             onClick={() => navigate('/settings/email-management')}
                           />
                         </CustomListItemText>
                         <img
                           src={right}
                           alt="right"
                           style={{ cursor: 'pointer' }}
                           onClick={() => navigate('/settings/email-management')}
                         />
                       </>
                      )}
                    </ListItem>
                  );
                })}
          </List>

          {role === 'guest' && (
            <Grid sx={{ px: 1.8, mt: 2 }}>
              <CustomGreenLargeButton
                onClick={() => navigate('/join')}
                type="submit"
                variant="contained"
                disableripple
                sx={{ mb: 1 }}
              >
                Join Now for full access
              </CustomGreenLargeButton>
            </Grid>
          )}
        </FormBoxA>
      </FormBox>
    </MainBox>
  );
};
export default Settings;
